import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import ThreeScene from "../components/ThreeScene";
import { services, WHATSAPP_URL, PHONE } from "../lib/data";

const iconMap = {
    gem: "fa-gem",
    stairs: "fa-stairs",
    building: "fa-building",
    shield: "fa-shield-halved",
    sparkles: "fa-wand-sparkles",
    wrench: "fa-screwdriver-wrench",
};

export default function Services() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
        }
    }, [hash]);

    return (
        <main data-testid="services-page">
            {/* HERO */}
            <section className="relative min-h-[70vh] dark-marble-bg overflow-hidden grain">
                <div className="absolute inset-0 opacity-40">
                    <ThreeScene variant="side" />
                </div>
                <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 pb-20 text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="eyebrow mb-4">خدماتنا</div>
                        <h1 className="hero-title text-white mb-6">
                            حرفية <span className="gold-text">تتجاوز التوقعات</span>
                        </h1>
                        <p className="text-white/70 text-lg max-w-2xl mx-auto">
                            منظومة متكاملة من خدمات جلي وتلميع وعزل الرخام بأعلى معايير الجودة العالمية.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* SERVICES LIST */}
            <section className="marble-bg py-20">
                <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-24">
                    {services.map((s, i) => (
                        <motion.article
                            id={s.id}
                            key={s.id}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.7 }}
                            className={`grid lg:grid-cols-2 gap-10 items-center scroll-mt-24 ${i % 2 === 1 ? "lg:[direction:ltr] lg:[&>*]:[direction:rtl]" : ""}`}
                            data-testid={`service-detail-${s.id}`}
                        >
                            <div className="relative rounded-3xl overflow-hidden gold-ring aspect-[4/3]">
                                <img src={s.image} alt={s.title} className="w-full h-full object-cover gallery-img" />
                                <div className="absolute top-6 right-6 w-16 h-16 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg, #e8c86a, #8a6d2b)", boxShadow: "0 10px 30px -5px rgba(201,169,97,0.6)" }}>
                                    <i className={`fa-solid ${iconMap[s.icon]} text-[#0a0a0a] text-xl`} />
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="font-latin gold-text text-6xl md:text-7xl mb-2 opacity-40">{String(i + 1).padStart(2, "0")}</div>
                                <h2 className="section-title text-[#0a0a0a] mb-4">{s.title}</h2>
                                <div className="divider-gold mb-6" />
                                <p className="text-[#0a0a0a]/75 text-lg leading-relaxed mb-6">{s.desc}</p>
                                <ul className="grid sm:grid-cols-2 gap-3 mb-8">
                                    {s.features.map((f, k) => (
                                        <li key={k} className="flex items-center gap-2 justify-end text-[#0a0a0a]/80 text-sm">
                                            {f}
                                            <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #e8c86a, #c9a961)" }}>
                                                <i className="fa-solid fa-check text-[10px] text-[#0a0a0a]" />
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="flex gap-3 flex-wrap">
                                    <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="gold-btn" data-testid={`service-whatsapp-${s.id}`}>
                                        <i className="fa-brands fa-whatsapp ml-2" />اطلب الخدمة
                                    </a>
                                    <a href={`tel:${PHONE}`} className="outline-btn">
                                        <i className="fa-solid fa-phone ml-2" />اتصل الآن
                                    </a>
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </section>
        </main>
    );
}
